import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { Vendor, Table } from 'services/action';
import { Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  selectedEntities: null,
  name: '',
  company_name: '',
  pic_name: '',
  pic_phone: '',
  pic_email: '',
  address: '',
};

const entitiesOptions = [
  { value: 'community', label: 'Community' },
  { value: 'personal', label: 'Personal' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'instansi', label: 'Instansi' },
];

export const FormInput = ({ data, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['vendor']);

  const dummy = Array.from({ length: 7 }, (v, i) => i);

  const [
    {
      selectedEntities,
      name,
      company_name,
      pic_name,
      pic_phone,
      pic_email,
      address,
      isLoading,
    },
    setState,
  ] = React.useState(initialState);

  const $handleSubmit = async (c) => {
    const payload = {
      type: 'vendor',
      entities: selectedEntities?.value || '',
      name,
      company_name,
      pic_name,
      pic_phone,
      pic_email,
      address,
    };

    if (data) {
      const submit = await Dispatch(Vendor.$update(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('vendor', StateTable));
      }
    } else {
      const submit = await Dispatch(Vendor.$create(payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('vendor', StateTable));
      }
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    const entities =
      data?.entities === 'community'
        ? entitiesOptions[0]
        : data?.entities === 'personal'
        ? entitiesOptions[1]
        : data?.entities === 'corporate'
        ? entitiesOptions[2]
        : data?.entities === 'instansi'
        ? entitiesOptions[3]
        : null;

    setState((prevState) => ({
      ...prevState,
      selectedEntities: entities,
      name: data?.name,
      pic_name: data?.pic_name,
      pic_phone: data?.pic_phone,
      pic_email: data?.pic_email,
      address: data?.address,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <Modal.Body>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </Modal.Body>
    );
  }

  return (
    <>
      <Modal.Body>
        <div className="row ">
          <div className="col-12 col-md-6">
            <div className="mb-3">
              <label className='form-label required'>Entities</label>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.pricing_schema ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={selectedEntities}
                options={entitiesOptions}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    selectedEntities: e,
                  }))
                }
                error={StateForm?.errors?.entities}
              />

              {StateForm?.errors?.entities ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.entities}
                </div>
              ) : null}
            </div>

            <Form.Input
              required
              value={name}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, name: e.target.value }))
              }
              error={StateForm?.errors?.name}
              type="text"
              label="Nama Vendor"
            />

            <Form.Input
              label="Nama Perusahaan"
              type="text"
              value={company_name}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  company_name: e.target.value,
                }))
              }
              error={StateForm?.errors?.company_name}
            />

            <Form.Textbox
              value={address}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  address: e.target.value,
                }))
              }
              error={StateForm?.errors?.address}
              rows={4}
              label="Alamat Vendor"
            />
          </div>
          <div className="col-12 col-md-6">
            <Form.Input
              required
              value={pic_name}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  pic_name: e.target.value,
                }))
              }
              error={StateForm?.errors?.pic_name}
              type="text"
              label="Nama Penanggung Jawab"
            />
            <Form.Input
              required
              value={pic_phone}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  pic_phone: e.target.value,
                }))
              }
              error={StateForm?.errors?.pic_phone}
              type="phone"
              label="Nomor HP Penanggung Jawab"
            />
            <Form.Input
              value={pic_email}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  pic_email: e.target.value,
                }))
              }
              error={StateForm?.errors?.pic_email}
              type="email"
              label="Email Penanggung Jawab "
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button
              type="button"
              className='btn btn-light w-100'
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                  'btn btn-primary w-100'
                )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
